module.exports = __webpack_public_path__ + "img/store1.811510c.webp";